import { Provider } from '@angular/core';
import { TUI_SVG_SRC_PROCESSOR } from '@taiga-ui/core';

export const provideSvgSrcProcessor: Provider = {
    provide: TUI_SVG_SRC_PROCESSOR,
    useFactory: () => {
        // replace tuiIcon with custom icon
        // const items = {
        //     tuiIconCancel: 'cancel'
        // };

        return (src: string): string => {
            if (src.startsWith('svg::')) {
                return `assets/svg/${src.replace(`svg::`, ``)}.svg`;
            }
            if (src.startsWith('icon::')) {
                return `assets/icons/${src.replace(`icon::`, ``)}.svg`;
            }
            return src;
        };
    }
};
